import React from "react";

type RoundTripIconProps = {
  color?: string;
  size?: "small";
};

const RoundTripIcon = (props: RoundTripIconProps) => {
  const { color, size } = props;

  if (size === "small") {
    return (
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 5V8.69302C4 9.30487 4.23705 9.89166 4.65901 10.3243C5.08097 10.7569 5.65326 11 6.25 11H13M4 5L7 8M4 5L1 8M12 7V3.30698C12 2.69513 11.7629 2.10834 11.341 1.6757C10.919 1.24306 10.3467 1 9.75 1L3 1M12 7L9 4M12 7L15 4"
          stroke={color || "#999999"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 5V8.69302C4 9.30487 4.23705 9.89166 4.65901 10.3243C5.08097 10.7569 5.65326 11 6.25 11H13M4 5L7 8M4 5L1 8M12 7V3.30698C12 2.69513 11.7629 2.10834 11.341 1.6757C10.919 1.24306 10.3467 1 9.75 1L3 1M12 7L9 4M12 7L15 4"
        stroke={color || "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RoundTripIcon;
